export default {
  SHOW_DIFM_BANNER: 'show_difm_banner',
  IS_LATEST_USER_AGREEMENT_ACCEPTED: 'is_latest_user_agreement_accepted',
};
